import _ from 'lodash';
import moment from 'moment';
import InteractsWithState from 'mixins/InteractsWithState';

export default {
  mixins: [InteractsWithState],

  computed: {
    label_printed() {
      return this.order.label_printed_at != null;
    },

    items() {
      return _.get(this.order, 'items.data', []);
    },

    customer() {
      return this.order.customer || {};
    },

    item_count() {
      return this.items.length || this.order.item_count || 0;
    },

    processed_item_count() {
      return (
        this.processed_items.length || this.order.processed_item_count || 0
      );
    },

    processed_items() {
      return this.items.filter(item => !!item.processed_at);
    },

    completed_items() {
      return this.items.filter(item => !!item.completed_at);
    },

    unavailable_items() {
      return this.items.filter(item => !item.product.in_stock);
    },

    subtotal() {
      const total = this.items.reduce((sum, item) => {
        // sum the addon prices. Each addon option is multiplied by the item quantity.
        const preferences = _(item)
          .get('preferences.data', [])
          .reduce((sub, preference) => {
            if (!preference.price) {
              return sub;
            }

            return sub + item.quantity * preference.price;
          }, 0);

        // add the addon price to the item price * quantity for the total
        return sum + item.quantity * item.price + preferences;
      }, 0);

      return ((total || this.order.subtotal) / 100).toFixed(2);
    },

    nearby() {
      return this.order.nearby_at !== null;
    },

    status_classes() {
      const classes = ['order'];
      const pickupAt = moment.utc(this.order.pickup_at).local();
      const now = this.state.time.clone();

      if (this.order.status.toLowerCase() !== 'completed') {
        if (pickupAt < now) {
          // past due!
          classes.push('danger');
        } else if (pickupAt <= now.add(5, 'minutes')) {
          // almost due!
          classes.push('warning');
        } else if (pickupAt < now.add(55, 'minutes')) {
          // 'current' order
          classes.push('success');
        }
      }

      return classes.join(' ');
    },

    weight() {
      return (
        _.reduce(
          this.items,
          (acc, item) => {
            switch (item.product.unit_of_measure) {
              case 'pound':
                return acc + +item.quantity;
              case 'dry oz':
                return acc + Number(item.quantity) / 16;
              default:
                return acc;
            }
          },
          0
        ) || this.order.weight
      );
    },

    can_complete() {
      if (this.completed) {
        return false;
      }

      return (
        this.completed_items.length + this.unavailable_items.length ===
          this.items.length && this.completed_items.length > 0
      );
    },

    can_cancel() {
      if (this.completed) {
        return false;
      }

      return this.unavailable_items.length === this.items.length;
    },

    can_add_items() {
      return !this.completed;
    },

    completed: {
      get() {
        return this.order.completed_at != null;
      },
      set(v) {
        if (v) {
          this.order.completed_at = moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
          this.order.status = 'Completed';
        } else {
          this.order.completed_at = null;
          this.order.status = 'Processing';
        }
      },
    },

    canceled: {
      get() {
        return this.order.canceled_at != null;
      },
      set(v) {
        if (v) {
          this.order.canceled_at = moment().utc().format('YYYY-MM-DD HH:mm:ss');
          this.order.status = 'Canceled';
        } else {
          this.order.canceled_at = null;
          this.order.status = 'Processing';
        }
      },
    },

    last_name() {
      const value = this.customer.last_name;

      if (/^\d+$/.test(value)) {
        return `(#${value})`;
      }

      return value;
    },

    overdue() {
      return (
        !this.completed && moment.utc(this.order.pickup_at).local() < moment()
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/DescribesAnOrder.js